/**
 * グローバルナビ（スライドメニュー）
 * - jQuery前提
 */

export function slideMenu($, opts = {}) {
  const options = {
    bodyClass: 'slide-open',
    btnSelector: '#js__slideMenuBtn',
    overlaySelector: '#js__overlay',
    closeBtnSelector: '#js__slideMenuClose',
    ...opts,
  };

  const $body = $('body');
  const $toggleBtn = $(options.btnSelector);

  if (!$toggleBtn.length) return { destroy() {} };

  const open = () => $body.addClass(options.bodyClass);
  const close = () => $body.removeClass(options.bodyClass);
  const toggle = () => ($body.hasClass(options.bodyClass) ? close() : open());

  const onBtnClick = (e) => {
    e.preventDefault();
    toggle();
  };

  const onOverlayClick = (e) => {
    e.preventDefault();
    close();
  };

  const onCloseBtnClick = (e) => {
    e.preventDefault();
    close();
  };

  // toggleボタン
  $toggleBtn.off('click.gNav').on('click.gNav', onBtnClick);

  // overlay
  $(document).off('click.gNav', options.overlaySelector).on('click.gNav', options.overlaySelector, onOverlayClick);

  // closeボタン
  $(document).off('click.gNav', options.closeBtnSelector).on('click.gNav', options.closeBtnSelector, onCloseBtnClick);

  function destroy() {
    $toggleBtn.off('click.gNav');
    $(document).off('click.gNav', options.overlaySelector);
    $(document).off('click.gNav', options.closeBtnSelector);
  }

  return { destroy };
}

/**
 * アコーディオン
 * - a.noscroll の次要素を開閉
 */

export function accordionPanel($, opts = {}) {
  const options = {
    selector: 'a.noscroll',
    openClass: 'open',
    ...opts,
  };

  const $links = $(options.selector);
  if (!$links.length) return { destroy() {} };

  const onClick = function (e) {
    e.preventDefault();
    $(this).next().stop(true, true).slideToggle();
    $(this).toggleClass(options.openClass);
  };

  $links.off('click.accordion').on('click.accordion', onClick);

  function destroy() {
    $links.off('click.accordion');
  }

  return { destroy };
}
